import React from "react";
import { View } from "react-native";
import { ThemeType } from "../../theme/theme";
import { useTheme } from "react-native-paper";

export interface ISpacer {
  size?: keyof ThemeType["spacing"];
}
export const Spacer = ({ size = "medium" }: ISpacer) => {
  const theme = useTheme() as ThemeType;
  const width = theme.spacing[size];
  const height = theme.spacing[size];
  return <View style={{ width, height }}></View>;
};
